import React from "react";

export default function Error() {
  return (
    <div className="errorScreen">
      <p>Sorry</p>
      <p>Look's like we have used up all the search requests</p>
      <p>Please be back after a month</p>
    </div>
  );
}
